import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "buttonDiv"
}

import { inject, ref } from 'vue'
import { DEFAULT_CONFIG, useConfig } from '@/config/useConfig'
import { until, useAsyncState } from '@vueuse/core'
import { SsoConfig } from '@/types/interfaces'

declare global {
  const google: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleLoginButton',
  emits: ['googleLogin'],
  setup(__props, { emit: __emit }) {

const loadGoogleClient = inject('loadGoogleClient') as () => Promise<boolean>
const handleGoogleLogin = (response: any) => {
  emit('googleLogin', {
    googleToken: response.credential
  })
}

const renderGoogleButton = (config: SsoConfig) => {
  const clientId = config.api?.google_client_id
  if (!clientId) return

  loadGoogleClient().then(() => {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: handleGoogleLogin
    })

    google.accounts.id.renderButton(
      document.getElementById('buttonDiv'),
      { theme: 'outline', width: '400' }
    )
  })
}

const { state, isReady } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
);
(async () => {
  await until(isReady).toBe(true)
  renderGoogleButton(state.value)
})()

const googleClientId = ref(state.value.api?.google_client_id)
const hideButton = ref(googleClientId.value === undefined)

const emit = __emit


return (_ctx: any,_cache: any) => {
  return (!hideButton.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})